// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__AmsH5","resendInfoText":"OnGoingPaymentBox_resendInfoText__2DXOl"};